var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { DataLocationStorageType, AuthenticationType } from "../../models/DataSourceDataCommon.js";
import { getNewGuid } from "@ane/core/lib/utils/CommonStringUtils";
import { d as getDataSourceTypeLocation, e as getFileFormat, f as getProfileJobConfigurationFrequency, P as ProfilingOptions, h as validateBasicInfo, i as validateDataLocationInfo, j as validateSpecialColumnsInfo, b as validateParameterInfo, c as validateAvailabilityStreamInfo, k as genErrorMessageDataLocationInfo, l as getCosmosViewDefaultParameter, g as genErrorMessageParameterInfo, a as genErrorMessageAvailabilityStreamInfo, m as getProfileJobConfigurationFrequencyFriendlyName } from "../../../../../DataSourceFormikSettingsUtils-f721237d.js";
import { notDeleteKey } from "../../../DataSourceDetail/ducks/DataSourceDetailConstants.js";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
import Logger from "@ane/core/lib/services/logging/Logger";
import { TelemetryEventName } from "../../../../constants/TelemetryEventName.js";
const convertToPostParams = (props) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o;
  let storageType = props.storageType;
  const locationRes = getDataSourceTypeLocation(props);
  const experimentConfiguration = {
    RandomizationUnits: props.randomizationList ? props.randomizationList.map(({ ColumnName, NGPColumnTag, NGPStreamTag }) => ({
      Name: ColumnName,
      NGPColumnTag: NGPColumnTag ? new RegExp(/\[|\]/).test(NGPColumnTag) ? NGPColumnTag : `[${NGPColumnTag}]` : void 0,
      NGPStreamTag: NGPStreamTag ? new RegExp(/\[|\]/).test(NGPStreamTag) ? NGPStreamTag : `[${NGPStreamTag}]` : void 0
    })) : [],
    TimeStamps: props.timestampList ? props.timestampList.map(({ ColumnName, NonNullable }) => ({ Name: ColumnName, Nullable: !NonNullable })) : [],
    Flights: props.flightList ? props.flightList.map(
      ({ ColumnName, Example, Definition, Source }) => ({
        Name: ColumnName,
        Format: {
          Source,
          Example,
          Definition
        }
      })
    ) : []
  };
  let postParams = {
    Version: getNewGuid(),
    WorkspaceId: props.workspaceId,
    Name: props.name,
    DataSourceType: props.dataSourceType,
    Owners: props.owners,
    IsUTC: props.isUTC === "True" ? true : false,
    OffsetInHours: props.isUTC === "True" ? 0 : 8,
    CosmosLocation: storageType !== DataLocationStorageType.Cosmos ? null : locationRes,
    AzureBlobLocation: storageType !== DataLocationStorageType.AzureBlob ? null : locationRes,
    ADLSGen2Location: storageType !== DataLocationStorageType.ADLSGen2 ? null : locationRes,
    ADLSGen2CosmosViewLocation: storageType !== DataLocationStorageType.ADLSGen2CosmosView ? null : locationRes,
    AuthenticationId: (storageType === DataLocationStorageType.ADLSGen2 || storageType === DataLocationStorageType.ADLSGen2CosmosView || storageType === DataLocationStorageType.Cosmos) && (props.authenticationType === AuthenticationType.ServicePrincipal || !props.authenticationType) ? props.authenticationId : "",
    ManagedIdentityId: (storageType === DataLocationStorageType.AzureBlob || storageType === DataLocationStorageType.ADLSGen2 || storageType === DataLocationStorageType.ADLSGen2CosmosView || storageType === DataLocationStorageType.Cosmos) && (props.authenticationType === AuthenticationType.ManagedIdentity || !props.authenticationType) ? props.managedIdentityId : "",
    RetentionDayParams: props.retentionDaysParams,
    MTLocations: storageType !== DataLocationStorageType.MT ? null : [
      {
        DataPath: (_c = (_b = (_a = props.storageMTList) == null ? void 0 : _a[0]) == null ? void 0 : _b.DataPath) != null ? _c : "",
        EndPoint: (_f = (_e = (_d = props.storageMTList) == null ? void 0 : _d[0]) == null ? void 0 : _e.EndPoint) != null ? _f : "",
        Region: "",
        SubCluster: (_i = (_h = (_g = props.storageMTList) == null ? void 0 : _g[0]) == null ? void 0 : _h.SubCluster) != null ? _i : ""
      }
    ],
    FileFormat: getFileFormat(props),
    StorageType: storageType,
    AvailabilityStreams: props.streamList ? props.streamList.map(({ DataPath, VC, Cluster }) => ({
      DataPath,
      VC,
      Cluster
    })) : [],
    Parameters: props.parameterList ? props.parameterList.map(({ Name, Value, Type, SampleValue }, key) => ({
      Name,
      Value,
      Type,
      DefaultValue: (storageType === DataLocationStorageType.Cosmos || storageType === DataLocationStorageType.ADLSGen2CosmosView) && (key === 0 || key === 1) ? `today("${SampleValue}")` : SampleValue
    })) : [],
    PartitionCount: props.partitionCount,
    IsOverrideDataSource: false,
    ExperimentConfiguration: experimentConfiguration,
    IsDataContractEnabled: props.IsDataContractEnabled,
    ProfileJobConfiguration: {
      RequireProfile: (_j = props.isEnableProfiling) != null ? _j : false,
      Frequency: getProfileJobConfigurationFrequency(props.profilingFrequency),
      LastProfileTime: null
    },
    AAStreamConfig: {
      ExpiryDays: (_k = props.aaStreamConfig) == null ? void 0 : _k.ExpiryDays,
      LocationPrefix: (_l = props.aaStreamConfig) == null ? void 0 : _l.LocationPrefix
    },
    SampleConfig: {
      MainDataSources: ((_m = props.sampleConfig) == null ? void 0 : _m.MainDataSources) || [],
      SampleDataSources: ((_n = props.sampleConfig) == null ? void 0 : _n.SampleDataSources) || [],
      Comment: (_o = props.sampleConfig) == null ? void 0 : _o.Comment
    },
    HasIntersectingSchema: props.HasIntersectingSchema
  };
  return postParams;
};
const DataSourceCreateFormSettings = {
  mapPropsToValues: (props) => {
    return {
      name: "",
      dataSourceType: "",
      isUTC: "False",
      owners: [],
      subscribers: [],
      storageType: "",
      storageList: {},
      storageMTList: [],
      parameterList: [],
      streamList: [],
      randomizationList: [{ ColumnName: "", NGPColumnTag: "", NGPStreamTag: "" }],
      flightList: [{ ColumnName: "", Format: "", Definition: "", Source: "", Example: "" }],
      timestampList: [{ ColumnName: "", NonNullable: false }],
      dataContractErrorDetails: null,
      IsDataContractEnabled: true,
      isEnableProfiling: false,
      profilingFrequency: ProfilingOptions.Manual,
      aaStreamConfig: {
        ExpiryDays: 30,
        LocationPrefix: null
      }
    };
  },
  validate: (values, props) => {
    const initialValues = DataSourceCreateFormSettings.mapPropsToValues(props);
    let errors = {};
    errors = validateBasicInfo(values, props.workspaceId);
    errors = validateDataLocationInfo(values, errors, props.workspaceId, true);
    if (values.IsDataContractEnabled === true) {
      errors = validateSpecialColumnsInfo(values, errors, initialValues);
    }
    errors = validateParameterInfo(values, errors);
    errors = validateAvailabilityStreamInfo(values, errors);
    return errors;
  },
  validateOnChange: true,
  validateOnBlur: true,
  handleSubmit: (values, bag) => __async(void 0, null, function* () {
    var _a, _b, _c, _d, _e;
    (_e = (_d = bag.props).onSubmit) == null ? void 0 : _e.call(_d, {
      workspaceId: bag.props.workspaceId,
      name: values.name,
      dataSourceType: values.dataSourceType,
      owners: values.owners,
      subscribers: values.subscribers,
      retentionDaysParams: {
        DataSourceRetentionDays: values.retentionDays,
        DataSourceRetentionErrorMessage: values.retentionErrorMsg
      },
      isUTC: values.isUTC,
      storageType: values.storageType,
      storageList: values.storageList,
      parameterList: values.parameterList,
      streamList: values.streamList,
      storageMTList: values.storageMTList,
      randomizationList: values.randomizationList,
      flightList: values.flightList,
      timestampList: values.timestampList,
      IsDataContractEnabled: values.IsDataContractEnabled,
      isEnableProfiling: values.isEnableProfiling,
      profilingFrequency: values.profilingFrequency,
      authenticationId: values.authenticationId,
      authenticationType: values.authenticationType,
      managedIdentityId: values.managedIdentityId,
      partitionCount: values.partitionCount,
      aaStreamConfig: {
        ExpiryDays: (_a = values.aaStreamConfig) == null ? void 0 : _a.ExpiryDays,
        LocationPrefix: (_b = values.aaStreamConfig) == null ? void 0 : _b.LocationPrefix
      },
      sampleConfig: {
        MainDataSources: [],
        SampleDataSources: ((_c = values.linkedSampleDataSource) == null ? void 0 : _c.length) ? [values.linkedSampleDataSource[0]] : null,
        Comment: values.linkComment
      },
      HasIntersectingSchema: values.HasIntersectingSchema
    });
  })
};
const getPlaceholderName = (storageType, index) => {
  if ((storageType === DataLocationStorageType.Cosmos || storageType === DataLocationStorageType.ADLSGen2CosmosView) && index === 0) {
    return {
      Name: "e.g. StartDate",
      Value: 'eg: "2020-01-01"',
      SampleValue: 'eg: "2020-01-01"'
    };
  } else if ((storageType === DataLocationStorageType.Cosmos || storageType === DataLocationStorageType.ADLSGen2CosmosView) && index === 1) {
    return {
      Name: "e.g. EndDate",
      Value: 'eg: "2020-01-01"',
      SampleValue: 'eg: "2020-01-01"'
    };
  } else {
    return void 0;
  }
};
const parseCosmosDate = (defaultValue) => {
  if (defaultValue && /^today\("[-][0-9]+"\)$/.test(defaultValue)) {
    const match = defaultValue.match(/[-][0-9]+/g);
    return match ? match[0] : "";
  } else {
    return defaultValue;
  }
};
const DataSourceEditFormSettings = {
  mapPropsToValues: (props) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _A, _B, _C, _D, _E, _F, _G, _H, _I;
    let storageMTList = [];
    if (!((_a = props.dataSourceItem) == null ? void 0 : _a.data)) {
      return {
        name: "",
        dataSourceType: "",
        isUTC: "True",
        owners: [],
        subscribers: [],
        storageType: "",
        storageList: {},
        storageMTList: [],
        parameterList: [],
        streamList: [],
        randomizationList: [],
        flightList: [],
        timestampList: [],
        dataContractErrorDetails: null,
        IsDataContractEnabled: true,
        isEnableProfiling: false,
        profilingFrequency: ProfilingOptions.Manual,
        aaStreamConfig: {
          ExpiryDays: 30,
          LocationPrefix: null
        }
      };
    } else {
      const data = (_b = props.dataSourceItem) == null ? void 0 : _b.data;
      let storageList = {};
      if (data == null ? void 0 : data.StorageType) {
        if (data.StorageType === DataLocationStorageType.Cosmos) {
          storageList = {
            DataPath: data.CosmosLocation ? data.CosmosLocation.DataPath : "",
            VC: (_d = (_c = data.CosmosLocation) == null ? void 0 : _c.VC) != null ? _d : "",
            Cluster: (_f = (_e = data.CosmosLocation) == null ? void 0 : _e.Cluster) != null ? _f : ""
          };
          storageList = genErrorMessageDataLocationInfo(storageList);
        } else if (data.StorageType === DataLocationStorageType.AzureBlob) {
          storageList = {
            DataPath: data.AzureBlobLocation ? data.AzureBlobLocation.DataPath : "",
            StorageAccount: data.AzureBlobLocation ? data.AzureBlobLocation.StorageAccount : "",
            Container: data.AzureBlobLocation ? data.AzureBlobLocation.Container : ""
          };
          storageList = genErrorMessageDataLocationInfo(storageList);
        } else if (data.StorageType === DataLocationStorageType.ADLSGen2) {
          storageList = {
            DataPath: data.ADLSGen2Location ? data.ADLSGen2Location.DataPath : "",
            StorageAccount: data.ADLSGen2Location ? data.ADLSGen2Location.StorageAccount : "",
            Container: data.ADLSGen2Location ? data.ADLSGen2Location.Container : "",
            Url: data.ADLSGen2Location ? (_g = data.ADLSGen2Location.KeyVaultAuthentication) == null ? void 0 : _g.Url : "",
            SecretName: data.ADLSGen2Location ? (_h = data.ADLSGen2Location.KeyVaultAuthentication) == null ? void 0 : _h.SecretName : ""
          };
          storageList = genErrorMessageDataLocationInfo(storageList);
        } else if (data.StorageType === DataLocationStorageType.MT) {
          storageMTList = data ? (_i = data.MTLocations) == null ? void 0 : _i.map(({ Region, DataPath, EndPoint, SubCluster }, key) => ({
            Region,
            DataPath,
            EndPoint,
            SubCluster,
            required: {
              Region: "",
              DataPath: "",
              EndPoint: "",
              SubCluster: ""
            }
          })) : [];
        } else if (data.StorageType === DataLocationStorageType.ADLSGen2CosmosView) {
          storageList = {
            DataPath: data.ADLSGen2CosmosViewLocation ? data.ADLSGen2CosmosViewLocation.DataPath : "",
            StorageAccount: data.ADLSGen2CosmosViewLocation ? data.ADLSGen2CosmosViewLocation.StorageAccount : "",
            Container: data.ADLSGen2CosmosViewLocation ? data.ADLSGen2CosmosViewLocation.Container : ""
          };
        }
      }
      let parameters = [];
      if (data.Parameters) {
        parameters = data.Parameters.map(({ Name, Value, Type, DefaultValue }, key) => {
          const isCosmosDate = (data.StorageType === DataLocationStorageType.Cosmos || data.StorageType === DataLocationStorageType.ADLSGen2CosmosView) && (key === 0 || key === 1);
          const SampleValue = isCosmosDate ? parseCosmosDate(DefaultValue) : DefaultValue;
          const deleteProp = isCosmosDate ? notDeleteKey : null;
          const placeholder = getPlaceholderName(data.StorageType, key);
          return {
            Name: Name != null ? Name : "",
            Value: Value != null ? Value : "",
            Type: Type != null ? Type : "",
            SampleValue: SampleValue != null ? SampleValue : "",
            delete: deleteProp,
            required: {
              Name: "",
              Type: "",
              Value: "",
              SampleValue: ""
            },
            placeholder
          };
        });
      } else {
        switch (data.StorageType) {
          case DataLocationStorageType.ADLSGen2CosmosView:
          case DataLocationStorageType.Cosmos:
            parameters = getCosmosViewDefaultParameter();
            break;
          default:
            parameters = [];
            break;
        }
      }
      parameters = genErrorMessageParameterInfo(parameters, data.StorageType === DataLocationStorageType.Cosmos);
      let streams = data.AvailabilityStreams ? data.AvailabilityStreams.map(({ DataPath, VC, Cluster }, key) => ({
        DataPath,
        VC,
        Cluster,
        required: {
          DataPath: "",
          VC: "",
          Cluster: ""
        },
        delete: null
      })) : [];
      streams = genErrorMessageAvailabilityStreamInfo(streams);
      let randomizationList = ((_j = data.ExperimentConfiguration) == null ? void 0 : _j.RandomizationUnits) ? (_k = data.ExperimentConfiguration) == null ? void 0 : _k.RandomizationUnits.map(({ Name, NGPColumnTag, NGPStreamTag }, key) => ({
        ColumnName: Name,
        NGPColumnTag,
        NGPStreamTag
      })) : [];
      let timestampList = ((_l = data.ExperimentConfiguration) == null ? void 0 : _l.TimeStamps) ? (_m = data.ExperimentConfiguration) == null ? void 0 : _m.TimeStamps.map(({ Name, Nullable }, key) => ({
        ColumnName: Name,
        NonNullable: !Nullable
      })) : [];
      let flightList = ((_n = data.ExperimentConfiguration) == null ? void 0 : _n.Flights) ? (_o = data.ExperimentConfiguration) == null ? void 0 : _o.Flights.map(({ Name, Format }, key) => ({
        ColumnName: Name,
        Format: Format.Example,
        Source: Format.Source,
        Example: Format.Example,
        Definition: Format.Definition
      })) : [];
      let dataContractErrorDetails = null;
      if ((_s = (_r = (_q = (_p = props.dataSourceStatus) == null ? void 0 : _p.data) == null ? void 0 : _q.DataSourceValidationInfo) == null ? void 0 : _r.Report) == null ? void 0 : _s.ErrorDetails) {
        try {
          const errorDetails = JSON.parse(
            (_v = (_u = (_t = props.dataSourceStatus.data) == null ? void 0 : _t.DataSourceValidationInfo) == null ? void 0 : _u.Report) == null ? void 0 : _v.ErrorDetails
          );
          dataContractErrorDetails = errorDetails.DataContractColumnError;
        } catch (e) {
          const dataContractErrorDetails2 = {
            Details: "Failed to parse error details",
            DataContractColumnError: null
          };
          Logger.log(TelemetryEventName.App_DSMS_DataContract_ParseError, dataContractErrorDetails2);
        }
      }
      return {
        name: data.Name,
        dataSourceType: data.DataSourceType,
        isUTC: data.IsUTC ? "True" : "False",
        retentionErrorMsg: (_x = (_w = data.RetentionDayParams) == null ? void 0 : _w.DataSourceRetentionErrorMessage) != null ? _x : "",
        retentionDays: ((_y = data.RetentionDayParams) == null ? void 0 : _y.DataSourceRetentionDays) ? (_z = data.RetentionDayParams) == null ? void 0 : _z.DataSourceRetentionDays.toString() : "",
        owners: data.Owners ? data.Owners : [],
        subscribers: [],
        storageType: data == null ? void 0 : data.StorageType,
        storageList,
        storageMTList,
        parameterList: parameters,
        streamList: streams,
        randomizationList,
        flightList,
        timestampList,
        dataContractErrorDetails,
        IsDataContractEnabled: !!(data == null ? void 0 : data.IsDataContractEnabled),
        authenticationId: data.AuthenticationId,
        managedIdentityId: data.ManagedIdentityId,
        isEnableProfiling: !!(data == null ? void 0 : data.IsDataContractEnabled) && !!((_A = data == null ? void 0 : data.ProfileJobConfiguration) == null ? void 0 : _A.RequireProfile) && EnvironmentService.releaseDSMSdataprofiling(),
        partitionCount: data.PartitionCount,
        profilingFrequency: getProfileJobConfigurationFrequencyFriendlyName((_B = data == null ? void 0 : data.ProfileJobConfiguration) == null ? void 0 : _B.Frequency),
        aaStreamConfig: {
          ExpiryDays: (_D = (_C = data == null ? void 0 : data.AAStreamConfig) == null ? void 0 : _C.ExpiryDays) != null ? _D : 30,
          LocationPrefix: (_E = data == null ? void 0 : data.AAStreamConfig) == null ? void 0 : _E.LocationPrefix
        },
        linkedSampleDataSource: ((_F = data == null ? void 0 : data.SampleConfig) == null ? void 0 : _F.SampleDataSources) || [],
        linkComment: (_G = data == null ? void 0 : data.SampleConfig) == null ? void 0 : _G.Comment,
        sampleConfig: {
          MainDataSources: [],
          SampleDataSources: ((_H = data == null ? void 0 : data.SampleConfig) == null ? void 0 : _H.SampleDataSources) || [],
          Comment: (_I = data == null ? void 0 : data.SampleConfig) == null ? void 0 : _I.Comment
        },
        HasIntersectingSchema: data.HasIntersectingSchema
      };
    }
  },
  validate: (values, props) => {
    let errors = {};
    const initialValues = DataSourceEditFormSettings.mapPropsToValues(props);
    errors = validateBasicInfo(values, props.workspaceId);
    errors = validateDataLocationInfo(values, errors, props.workspaceId, false);
    if (values.IsDataContractEnabled === true) {
      errors = validateSpecialColumnsInfo(values, errors, initialValues);
    }
    errors = validateParameterInfo(__spreadProps(__spreadValues({}, values), { parameterList: values.parameterList }), errors);
    errors = validateAvailabilityStreamInfo(__spreadProps(__spreadValues({}, values), { streamList: values.streamList }), errors);
    return errors;
  },
  validateOnChange: true,
  validateOnBlur: true,
  handleSubmit: (values, bag) => __async(void 0, null, function* () {
    var _a, _b;
    (_b = (_a = bag.props).savePanel) == null ? void 0 : _b.call(_a, values);
  })
};
export {
  DataSourceCreateFormSettings,
  DataSourceEditFormSettings,
  convertToPostParams,
  getPlaceholderName,
  parseCosmosDate
};
//# sourceMappingURL=DataSourceCreateFormSettings.js.map
